import { DealDeliveryQuery } from 'utils/graphql/queries/__generated__/dealDelivery';

export enum DeliveryFileContextType {
  Default = 'default',
  DeliveryReport = 'delivery_report',
  DeliveryLabel = 'delivery_label',
}

export type DealDelivery = DealDeliveryQuery['dealDelivery'];
